var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoubleChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02461 13.4992L0.787109 9.26172L1.85586 8.21172L5.04336 11.3992L6.09336 12.4492L5.02461 13.4992ZM9.26211 13.4992L5.02461 9.26172L6.07461 8.19297L9.26211 11.3805L16.1621 4.48047L17.2121 5.54922L9.26211 13.4992ZM9.26211 9.26172L8.19336 8.21172L11.9059 4.49922L12.9746 5.54922L9.26211 9.26172Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoubleChecked);
export default __webpack_public_path__ + "static/media/icon-double-checked.d90b161856bf8f924462ada707b7599f.svg";
export { ForwardRef as ReactComponent };